var map = {
	"src/blueprint/packages/core/src/preset/load_preset_module": "./src/blueprint/packages/core/src/preset/load_preset_module.ts",
	"src/blueprint/packages/dev/src/preset/load-preset.module": "./src/blueprint/packages/dev/src/preset/load-preset.module.ts"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;